import { createReducer, createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
	getAffiliationRequests: ['userId'],
	getAffiliationRequestsDone: ['affiliationRequests', 'message'],
	getAffiliationRequestsError: ['errorMessage'],
	addAffiliationRequest: ['targetUserId'],
	addAffiliationRequestDone: ['message'],
	addAffiliationRequestError: ['errorMessage'],
	deleteAffiliationRequest: ['targetId', 'affiliationId'],
	deleteAffiliationRequestDone: ['message'],
	deleteAffiliationRequestError: ['errorMessage'],
	changeAffiliationRequestStatus: ['affiliationRequest'],
});

export const INITIAL_STATE = {
	affiliationRequests: [],
	message: '',
	errorMessage: '',
	loading: false,
};

export const AffiliationRequestsTypes = Types;
export default Creators;

const fetchRequest = (state) => ({
	...state,
	loading: true,
});

const getAffiliationRequestsDone = (state, { affiliationRequests, message }) => ({
	...state,
	loading: false,
	message,
	affiliationRequests,
})

const showErrorMessage = (state, { errorMessage }) => ({
	...state,
	loading: false,
	errorMessage,
});

const showMessage = (state, { message }) => ({
	...state,
	message,
	loading: false,
})

export const reducer = createReducer(INITIAL_STATE, {
	[Types.GET_AFFILIATION_REQUESTS]: fetchRequest,
	[Types.GET_AFFILIATION_REQUESTS_DONE]: getAffiliationRequestsDone,
	[Types.GET_AFFILIATION_REQUESTS_ERROR]: showErrorMessage,
	[Types.ADD_AFFILIATION_REQUEST]: fetchRequest,
	[Types.ADD_AFFILIATION_REQUEST_DONE]: showMessage,
	[Types.ADD_AFFILIATION_REQUEST_ERROR]: showErrorMessage,
	[Types.DELETE_AFFILIATION_REQUEST]: fetchRequest,
	[Types.DELETE_AFFILIATION_REQUEST_DONE]: showMessage,
	[Types.DELETE_AFFILIATION_REQUEST_ERROR]: showErrorMessage,
});